<script>
  import {normalized_video_store} from "./Utils/stores";
  import {active_video_store} from "./Utils/stores";
  import PlaylistItem from "./PlaylistItem.svelte";
  import {onMount} from "svelte";
  import Debug from "./Utils/Debug.svelte";
  export let videos
  export let activeVideoSlug
  let activeIndex = 0;

  $:  update_active_index(videos, activeVideoSlug)

  function update_active_index(videos, activeVideoSlug) {
    activeIndex = videos.findIndex(v => v.slug.current === activeVideoSlug);
  }

  function is_active(video) {
    return video.slug.current === activeVideoSlug;
  }

</script>
  <nav aria-label="Progress" class="vec-mt-4 vec-max-h-full">
    <ol class="step-list">
        {#each videos as video, i}
          <li class="item__list_item hover:vec-opacity-75">
            <PlaylistItem video={$normalized_video_store.videos[video.slug.current]}
                active={is_active(video)} played={i < activeIndex}
                last={i === videos.length -1}  on:video-clicked/>
          </li>
        {/each}
    </ol>
    
  </nav>
